<template lang="pug">
    Modal
        .form
            h2 Create a New Action Card
            .form__control-group
                label Display Name
                input(
                    v-model="displayName"
                    type="text"
                    placeholder="Display Name"
                )
            .form__control-group.rule__control-group--select
                label Card Type
                select.form__select(
                    v-model="cardType"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Card Type
                    option(
                        :key="type.name"
                        v-for="(type, index) in getCardTypes"
                        :value="type._id"
                    ) {{type.name}}
            .form__control-group.rule__control-group--select
                label Default Market
                select.form__select(
                    v-model="market"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Market
                    option(
                        :key="market.name"
                        v-for="(market, index) in getMarkets"
                        :value="market"
                    ) {{market.title}} - {{market.primaryLanguage}}
            button.button__submit(
                @click="submit"
            ) Create
            p(
                v-if="showError"
            ) Please enter a Display Name and select a Card Type.
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'CreateActionCard',
  components: {
    Modal
  },
  computed: {
    getCardTypes() {
      if (store.getters.getCardTypes.length) {
        return store.getters.getCardTypes;
      } else {
        Services.getCardTypes();
        return store.getters.getCardTypes;
      }
    },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
    return {
      displayName: '',
      cardType: '',
      market: '',
      showError: false,
      inSequence: this.$route.name === 'sequenceTemplate',
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit() {
      if (!this.displayName || !this.cardType) {
        this.showError = true;
        return false;
      }
      let newCard = {};

      newCard.displayName = this.displayName;

      newCard.cardType = this.cardType;

      newCard.markets = [this.market._id];

      newCard.fallbackLocale = this.market.locale;

      console.log(newCard);

      if(this.inSequence && store.getters.getActiveSequence._id) {
          newCard.sequence = store.getters.getActiveSequence._id;
      }

      postResource('/v1/actioncards/create', false, newCard)
        .then(res => {
          console.log('success!', res);
          this.showSuccessMsg({ message: `${this.displayName} card created!` });
          store.commit('hideModals', true);
          this.$router.push(`/cards/${res.card._id}`);
          return res;
        })
        .catch(error => {
          let message = 'An error occurred. Please try again.';
          if (error.message) {
            message = error.message;
          }
          return this.showErrorMsg({
            message
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    select,
    option {
      text-transform: capitalize;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CreateActionCard.vue